import { Camera, Video, Type, Mic } from 'lucide-react';
import { cn } from '@/lib/utils';

export type ContentType = 'photo' | 'video' | 'hudText' | 'voiceNote';

interface ContentTypeSelectorProps {
  selected: ContentType | null;
  onSelect: (type: ContentType) => void;
  disabled?: boolean;
}

const contentTypes = [
  { type: 'photo' as const, icon: Camera, label: 'Photo' },
  { type: 'video' as const, icon: Video, label: 'Video' },
  { type: 'hudText' as const, icon: Type, label: 'HUD Text' },
  { type: 'voiceNote' as const, icon: Mic, label: 'Voice' },
];

export function ContentTypeSelector({
  selected,
  onSelect,
  disabled,
}: ContentTypeSelectorProps) {
  return (
    <div className="grid grid-cols-4 gap-3">
      {contentTypes.map(({ type, icon: Icon, label }) => (
        <button
          key={type}
          type="button"
          onClick={() => onSelect(type)}
          disabled={disabled}
          className={cn(
            'flex flex-col items-center justify-center gap-2 p-4 rounded-xl border-2 transition-all duration-200',
            'hover:scale-105 active:scale-95',
            selected === type
              ? 'border-primary bg-primary/10 text-primary'
              : 'border-border bg-card hover:border-primary/50 text-muted-foreground hover:text-foreground',
            disabled && 'opacity-50 pointer-events-none'
          )}
        >
          <Icon className="w-6 h-6" />
          <span className="text-xs font-medium">{label}</span>
        </button>
      ))}
    </div>
  );
}

